/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const KeyExportFormat = {
    Pkcs12: 'PKCS12',
    Pem: 'PEM'
} as const;

export type KeyExportFormat = typeof KeyExportFormat[keyof typeof KeyExportFormat];



